import * as angular from 'angular';

import MobileDetectService from './mobileDetect.service';

export default angular.module('fp:activationswizard:common:mobile', [])
.service('mobileDetectService', MobileDetectService);